<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col sm="12">
      <transition name="slide">
      <b-card>
        <div slot="header">
          <div class="row pl-2 pr-2">
            <b-col sm="12" lg="8" class=" p-1 title">
              <span>Perfis de Usuários</span>
            </b-col>
            <b-col sm="12" lg="3" class="input-group input-group-sm p-1">
              <b-form-select class="select" v-model="provider" id="user-provider-environment" @change="changeProvider()">
                <option value="vault">Vault</option>
                <option value="bird">Bird</option>
              </b-form-select>
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="searchValue" v-on:input="search">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-success" type="button" @click="search" @click.stop.prevent><i class="fa fa-search"></i></button>
              </span>
            </b-col>
            <b-col sm="12" lg="1" class=" p-1">
              <b-button type="button" size="sm" variant="success" class="form-control" @click="userNew">Novo</b-button>
            </b-col>
          </div>
        </div>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="filteredItems" :fields="fields" @row-clicked="rowClicked">
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="username" slot-scope="data">
            <strong>{{data.item.username}}</strong>
          </template>
          <template slot="roles" slot-scope="data">{{data.item.roleNames.join(", ")}}</template>
        </b-table>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Users',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Usuários'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      filteredItems: [],
      fields: [
        {key: 'username', label: 'CPF/CNPJ'},
        {key: 'name', label: 'Nome'},
        {key: 'roles', label: 'Perfis'}
      ],
      provider: 'vault',
      searchValue: "",
      loadCount: 0,
    }
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    rowClicked (item) {
      this.$router.push({path: `users-role/edit/${this.provider}/${item.username}`})
    },
    userNew () {
      this.$router.push(`users-role/new/${this.provider}`);
    },
    changeProvider () {
      this.getUsers(this.searchValue);
    },
    search () {
      let reg = new RegExp(this.searchValue, 'ig');
      this.filteredItems = this.items.filter((i) => {
        return i.name.match(reg) || i.username.match(reg);
      });
    },
    getUsers (search = "") {
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-roles?provider=${this.provider}&search=${search}`)
        .then(function(response) {
          response.data.users.forEach(itm => {
            var roleNames = [];
            itm.roles.forEach(role => {
              roleNames.push(role.name);
            });
            itm.roleNames = roleNames;
          });
          _this.items = response.data.users;
          _this.filteredItems = _this.items;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.search-area {
  max-width: 280px;
}
.input-txt {
  height: 32px !important;
}
.select {
  height: 32px !important;
}
@media screen and (max-width: 468px) {
  .title {
    text-align: center;
  }
}
</style>
